import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { FinancialStatement } from '../models/financial-statement';
import { environment } from 'src/environments/environment';
import { SortData } from '../models/sort-data';
import { Observable } from 'rxjs';
import { PagedData } from '../models/paged-data';
import { WrapperService } from '../utils/wrapper-service';
import { TransferState } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FinancialStatementService {

  constructor(
  @Inject(PLATFORM_ID) private platformId: Object,
  private transferHttp: TransferState,
  private http: HttpClient) { }

  urlSuffixPath= `${environment.serviceApiUrl}/financial-statement`;

  getPageAbleList(sortData: SortData<FinancialStatement>): Observable<PagedData<FinancialStatement>> {
    let postUrl = `${this.urlSuffixPath}` + "/pageable-list";
    return WrapperService.getData(this.transferHttp,this.platformId,postUrl, sortData, () => {
    return this.http.post(postUrl, sortData);
  })
  }
}
